/**
 * Task #66600 — plafond mensal de despesa de um ativo.
 * Agrupa uma ou mais tipologias (ex.: portagens + estacionamento) num único limite mensal que
 * reinicia todos os meses, sem acumular o saldo não usado.
 */

/** Natureza de cada tipologia. As manutenções não são um tipo de despesa, daí o discriminador. */
export enum PlafondTypeKind {
    CHARGE_TYPE = 'CHARGE_TYPE',
    MAINTENANCE = 'MAINTENANCE',
}

export interface VehicleExpensePlafondTypeDto {
    /** Id do tipo de despesa. Vazio quando kind é MAINTENANCE. */
    typeId?: string;
    kind: PlafondTypeKind;
    /** Nome do tipo de despesa; vazio para MAINTENANCE (o rótulo vem das traduções). */
    typeName?: string;
    isSystem?: boolean;
    color?: string;
}

export interface VehicleExpensePlafondDto {
    id?: string;
    vehicleId: string;
    designation: string;
    monthlyLimit: number;
    notifyEnabled: boolean;
    types: VehicleExpensePlafondTypeDto[];
    /** Destinatários do aviso de excedência. */
    contacts: string[];
}

export interface ReplicateVehicleExpensePlafondsDto {
    sourceVehicleId: string;
    targetVehicleIds: string[];
}
